/**
 * Combina permisos por UNIÓN: un flag queda habilitado si está en cualquiera
 * de las fuentes. Cada fuente se normaliza ANTES con toGranular (spec
 * 2026-10-01-permisos-granulares §3), para que una fuente vieja (que hereda de
 * create/delete) no contagie a una nueva ni al revés.
 *
 * deleteLinked de fuentes viejas exigía `delete` DESPUÉS de unir (podían venir
 * de fuentes distintas). Para no quitar ese permiso, cada fuente vieja aporta su
 * deleteLinked crudo a `_legacyLinked`, y computeEffective lo resuelve al final.
 *
 * Devuelve SIEMPRE el set canónico de flags como booleanos.
 */
import { toGranular, legacyLinkedRaw, GRANULAR_DOC_FLAGS } from './permission_granular';

const FOLDER_FLAGS = ['read', 'create', 'update', 'delete', 'closing', 'download'];

const flagOf = (p, group, flag) => !!(p && p[group] && p[group][flag]);

export const mergePermissions = (global, matrix) => {
  const g = toGranular(global);
  const m = toGranular(matrix);
  const documents = {};
  GRANULAR_DOC_FLAGS.forEach((f) => { documents[f] = flagOf(g, 'documents', f) || flagOf(m, 'documents', f); });
  documents._legacyLinked = legacyLinkedRaw(global) || legacyLinkedRaw(matrix)
    || flagOf(global, 'documents', '_legacyLinked') || flagOf(matrix, 'documents', '_legacyLinked');
  // El resultado ya está normalizado: si vuelve a entrar (computeEffective
  // encadena tres uniones), se lee tal cual y no hereda otra vez.
  documents.granular = true;
  const folders = {};
  FOLDER_FLAGS.forEach((f) => { folders[f] = flagOf(g, 'folders', f) || flagOf(m, 'folders', f); });
  return { documents, folders };
};

export default mergePermissions;
